// Setting a cookie for user coming from Epilepsy:]
function getExpiryTime() {
	var date = new Date();
	date.setHours(date.getHours() + 24);
	return date.toGMTString();
}

function setEpilepsyCookie() {
	var utmQueryStr = 'utm_source=epilepsy_advocate_seizure_clusters';
	var expiryTime = getExpiryTime();
	if ( window.location.search.indexOf(utmQueryStr) > -1 ) {
		document.cookie = 'epilepsyUsr=epilepsy_advocate_seizure_clusters' + '; expires= ' + expiryTime + (window.location.protocol == 'https:' ? '; secure' : '') + '; samesite=None';
	}
}

setEpilepsyCookie();

function populateEpilepsyCookie() {
    var cookies = document.cookie.split(';');
    var epilepsyCookie = cookies.filter( function(cookie) {
        return cookie.indexOf('epilepsyUsr') !== -1
    }).toString();
    if (epilepsyCookie.length > 0) {
        var epilepsyCookieVal = epilepsyCookie.split('epilepsyUsr=')[1];
        document.querySelector('input[name=epilepsy_user_cookie]').value = epilepsyCookieVal;
    } 
};